import { z } from 'zod';

import { ShotContention, ShotLoad, ShotOrigin, ShotOriginArea, ShotResult } from '../statistics';
import { ExploreEventType } from './explore-event-type';

export type ExploreEvent<TType extends ExploreEventType = ExploreEventType> =
  ExploreEventByType[TType];

export type ExploreEventDTO<TType extends ExploreEventType = ExploreEventType> =
  ExploreEventDTOByType[TType];

export type ExploreEventByType = {
  [ExploreEventType.SHOT]: ShotExploreEvent;
};

export type ExploreEventDTOByType = {
  [ExploreEventType.SHOT]: ShotExploreEventDTO;
};

export type ShotExploreEvent = z.output<typeof shotExploreEventSchema>;
export type ShotExploreEventDTO = z.input<typeof shotExploreEventSchema>;

const shotExploreEventSchema = z.object({
  type: z.literal(ExploreEventType.SHOT),

  shotContention: z.array(z.enum(ShotContention)).default([]),
  shotLoad: z.array(z.enum(ShotLoad)).default([]),
  shotOrigin: z.array(z.enum(ShotOrigin)).default([]),
  shotOriginArea: z.array(z.enum(ShotOriginArea)).default([]),
  shotResult: z.array(z.enum(ShotResult)).default([]),
});

export const exploreEventSchema = z.discriminatedUnion('type', [shotExploreEventSchema]);
